<template>

  <div class="layout__container layout__padding-20-0">
    <div class="layout__padding-clear layout__width-800px">
      <StepGuide :stepCount="1"></StepGuide>
    </div>

    <!--{{this.preferences}}-->

    <!--<br>-->

    <!--{{this.jobItem.printJobSpec}}<br>-->

    <!--{{this.jobItem.printJobSpec.stockType}}-->

    <div class="text__align-center text__colour-white">
      <div class="layout__padding-clear layout__width-50">
        <h2 class="text__colour-teal layout__padding-40px-0">Select Print Options</h2>
      </div>
    </div>

    <div class="layout__padding-clear layout__width-80">
      <el-button
        class="button-red button__base layout__width-200px layout__position-right layout__margin__bottom-25px"
        :disabled="incompleteOrder"
        @click="savePreferences()"
      >Save my preferences
      </el-button>

      <div id="success">
        <p class="component__message-base component__message-success">Your print preferences have been successfully
          saved
        </p>
      </div>
      <div id="error">
        <p class="component__message-base component__message-fail">There was a problem saving your print preferences,
          please try again.
          <br>
          If the problem persists please contact our customer support team
        </p>
      </div>
    </div>


    <div class="layout__padding-clear layout__width-80 text__align-center">
      <div class="layout__position-center">
        <span>
          <span
            v-if="this.activeTab === 'weight' || this.activeTab === 'lam'"
            class="text__colour-black layout__position-right"
          >
            <el-popover
              placement="bottom-start"
              title="Need Support?"
              trigger="hover"
              class="text__align-center"
            >
              <div class="layout__width-250px">
                <p>Ravensworth Client Services</p>
                <p>
                  <span
                    class="text__colour-red layout__padding__right-2 text__style-bold-900"
                  >e:
                  </span>
                  client.support@ravensworth.co.uk
                </p>
                <p>
                  <span
                    class="text__colour-red layout__padding__right-2 text__style-bold-900"
                  >t:
                  </span>
                  0191 917 9331
                </p>
              </div>
              <span
                slot="reference"
                class="layout__border__none layout__padding-clear"
              >
                <i
                  class="text__size-24 el-icon-info text__colour-teal layout__padding__right-20px"
                ></i>
              </span>
            </el-popover>
          </span>
        </span>
      </div>
      <div class="layout__padding-clear">

        <el-tabs
          :tab-position="tabPosition"
          style="height: 500px;"
          type="border-card"
          v-model="activeTab"
        >
          <el-tab-pane name="style">
            <span
              slot="label"
              class=""
            >
              <div class="layout__padding-30-10">
                <img
                  class="layout__width-60px"
                  src="https://rpsassets.blob.core.windows.net/rpsimages/images/instant_print/PaperType.png"
                >
                <div class="paddingLabels">Paper
                  <br>
                  Type
                </div>
              </div>
            </span>
            <div class="layout__padding-0-20">
              <el-radio-group
                v-model="jobItem.printJobSpec.stockType"
                @change="postPaperType()"
                id="style"
                class="layout__position-left layout__padding-20px"
              >
                <el-radio-button
                  v-for="(type) in types"
                  :label="type"
                  :key="type"
                  class="layout__position-left layout__border__all-1px-grey"
                >

                  <div class="layout__width-200px text__transform-caps">
                    <span
                      class="text__transform-upper"
                      v-if="type === 'LF23'"
                    >DURATRAN
                    </span>
                    <span
                      class="text__transform-upper"
                      v-else
                    >{{ type }}
                    </span>
                  </div>

                  <span
                    v-show="preferences.stockType === type"
                    style="z-index: 1000"
                    class="icon-tick text__colour-green component__promo text__size-24"
                  ></span>
                </el-radio-button>
              </el-radio-group>
            </div>
          </el-tab-pane>
          <el-tab-pane
            name="weight"
            :disabled="disableSelections"
          >
            <span
              slot="label"
              class="textAlignCenter paddingTabs"
            >
              <div class="layout__padding-30-10">
                <img
                  class="layout__width-60px"
                  src="https://rpsassets.blob.core.windows.net/rpsimages/images/instant_print/Weight.png"
                >
                <div class="paddingLabels">Paper
                  <br>
                  Weight
                </div>
              </div>
            </span>
            <div class="layout__padding-0-20">
              <el-radio-group
                v-model="jobItem.printJobSpec.stockWeight"
                @change="postPaperWeights()"
                id="weight"
                class="layout__position-left layout__padding-20px"
              >
                <el-radio-button
                  v-for="(weight) in weights"
                  :label="weight"
                  :key="weight"
                  class="layout__position-left layout__border__all-1px-grey"
                >
                  <div class="layout__width-200px">
                    <span>
                      <span v-if="weight === 'LF23'">DURATRAN</span>
                      <span v-if="weight === 'INTRAN'">INTRAN</span>
                      <span v-if="weight === 'TRU'">TRUCARD</span>
                      <span v-if="weight !== 'INTRAN' && weight !== 'LF23' && weight !== 'TRU'">{{ weight }}</span>
                      <span v-if="weight !== 'INTRAN' && weight !== 'LF23' && weight !== 'TRU'">gsm</span>
                    </span>
                  </div>
                  <span
                    v-show="weight === 350"
                    class="icon-promote text__colour-red component__promo text__size-24"
                  ></span>
                  <span
                    v-show="weight === 'LF23'"
                    style="z-index: 1000"
                    class="icon-promote text__colour-red component__promo text__size-24"
                  ></span>
                  <span
                    v-show="preferences.stockWeight === weight"
                    style="z-index: 1000"
                    class="icon-tick text__colour-green component__promo text__size-24"
                  ></span>
                  <!--<p v-show="jobItem.printJobSpec.stockWeight === weight" class="icon-tick text__colour-green text__size-20 layout__position-right"></p>-->
                </el-radio-button>
              </el-radio-group>
            </div>
          </el-tab-pane>
          <el-tab-pane
            name="lam"
            class="textAlignCenter"
            :disabled="disableSelections"
          >
            <span slot="label">
              <div class="layout__padding-30-10">
                <img
                  class="layout__width-60px"
                  src="https://rpsassets.blob.core.windows.net/rpsimages/images/instant_print/Lamination.png"
                >
                <div class="paddingLabels">Finishing</div>
              </div>
            </span>

            <div class="layout__padding-0-20">
              <div class="layout__padding-20px text__transform-upper">
                <div
                  v-for="(lamination) in laminations"
                  :key="lamination.productRef"
                  class="layout__position-left"
                >
                  <el-radio-group
                    v-model="jobItem.printJobSpec.lamination"
                    @change="postLamination(lamination)"
                    class="layout__position-left"
                  >
                    <el-radio-button
                      :label="lamination.finishing"
                      :key="lamination.finishing"
                      class="layout__position-left layout__border__all-1px-grey"
                    >
                      <div
                        class="layout__width-200px"
                        v-show="lamination.finishing === 'STANDARD' || lamination.finishing === '' || lamination.finishing === 'NONE' || lamination.finishing === 'SILK'"
                      >
                        No Lamination
                      </div>
                      <div
                        class="layout__width-200px"
                        v-show="lamination.finishing === 'MATT LAM'"
                      >
                        Matt Lamination
                      </div>
                      <div
                        class="layout__width-200px"
                        v-show="lamination.finishing === 'GLOSS LAM'"
                      >
                        Gloss Lamination
                      </div>
                      <div
                        class="layout__width-200px"
                        v-show="lamination.finishing === 'VELVET LAM'"
                      >
                        Velvet Lamination
                      </div>
                      <div
                        class="layout__width-200px"
                        v-show="lamination.finishing === 'SIMPLEX MATT'"
                      >
                        Simplex Matt Lamination
                      </div>
                      <div
                        class="layout__width-200px"
                        v-show="lamination.finishing === 'SIMPLEX GLOSS'"
                      >
                        Simplex Gloss Lamination
                      </div>
                      <span
                        v-show="preferences.finishing === lamination.finishing"
                        style="z-index: 1000"
                        class="icon-tick text__colour-green component__promo text__size-24"
                      ></span>
                    </el-radio-button>
                  </el-radio-group>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane
            name="quantity"
            class="textAlignCenter"
          >
            <span
              slot="label"
              class="textAlignCenter"
            >
              <div class="layout__padding-30-10">
                <img
                  class="layout__width-60px"
                  src="https://rpsassets.blob.core.windows.net/rpsimages/images/instant_print/Quantity.png"
                >
                <div class="paddingLabels">Quantity</div>
              </div>
            </span>

            <div class="layout__padding-0-20">
              <el-radio-group
                v-model="jobItem.printJobSpec.quantity"
                @change="postQuantity()"
                class="layout__position-left layout__padding-20px"
              >
                <el-radio-button
                  v-for="(quantity) in quantities"
                  :label="quantity"
                  :key="quantity"
                  class="layout__position-left layout__border__all-1px-grey"
                >
                  <div class="layout__width-150px">{{ quantity }}</div>
                  <span
                    v-show="preferences.quantity === quantity"
                    style="z-index: 1000"
                    class="icon-tick text__colour-green component__promo text__size-24"
                  ></span>
                </el-radio-button>
              </el-radio-group>

              <div class="">

                <el-form
                  :model="jobItem.printJobSpec"
                  status-icon
                  :rules="rules"
                  ref="jobItem.printJobSpec.quantity"
                  class="layout__padding-clear"
                >
                  <el-form-item
                    prop="quantity"
                    class="layout__padding-0-20"
                  >
                    <!--<div class="layout__position-left layout__width-150px layout__padding-0-20">-->
                    <span class="layout__padding-10px layout__position-left">
                      Or enter a quantity
                    </span>
                    <!--</div>-->
                    <el-input
                      class="layout__position-left layout__width-75"
                      placeholder="quantity"
                      v-model="jobItem.printJobSpec.quantity"
                      :disabled="jobItem.printJobSpec.productRef === null || jobItem.printJobSpec.productRef === ''"
                      clearable
                      @blur="postQuantity()"
                    ></el-input>
                  </el-form-item>
                </el-form>
              </div>

              <div
                v-if="jobItem.printJobSpec.envelopeAvailable"
                class="mb-20 mt-10"
                style="float: left; display: flex; align-items: center;"
              >
                <div class="text__align-left mr-10 text__colour-teal pl-10">Add envelope?</div>

                <el-radio-group
                  v-model="jobItem.printJobSpec.envelope"
                >
                  <el-radio-button
                    class="layout__border__all-1px-grey mb-0"
                    :key="true"
                    :label="true"
                  >
                    <div class="layout__width-50px">
                      Yes
                    </div>
                  </el-radio-button>

                  <el-radio-button
                    class="layout__border__all-1px-grey mb-0"
                    :key="false"
                    :label="false"
                  >
                    <div class="layout__width-50px">
                      No
                    </div>
                  </el-radio-button>
                </el-radio-group>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane disabled>
            <span
              slot="label"
              class=""
            >
              <div class="layout__padding-0-20 layout__width-400px">
                <!--<div class="layout__width-500px">-->
                <p class="text__colour-teal text__size-16 text__align-left">Print Selections</p>
                <!--</div>-->


                <div class="layout__padding-clear">
                  <div class="component__columns-2__no-padding">Product</div>
                  <div class="component__columns-2__no-padding text__transform-upper">
                    {{ this.jobItem.printJobSpec.name }}
                  </div>
                </div>
                <div class="layout__padding-clear">
                  <div class="component__columns-2__no-padding">Style</div>
                  <div class="component__columns-2__no-padding text__transform-upper">
                    <span v-if="this.jobItem.printJobSpec.stockType === 'LF23'">DURATRAN</span>
                    <span v-else>{{ this.jobItem.printJobSpec.stockType }}</span>
                    <span v-else="this.jobItem.printJobSpec.stockType">Not Selected</span>
                  </div>
                </div>
                <div class="layout__padding-clear">
                  <div class="component__columns-2__no-padding">Weight</div>
                  <div class="component__columns-2__no-padding text__transform-upper">
                    <span v-if="!this.jobItem.printJobSpec.stockType">Not Selected</span>
                    <span v-if="this.jobItem.printJobSpec.stockWeight === 'INTRAN' || this.jobItem.printJobSpec.stockWeight === 'LF23' || this.jobItem.printJobSpec.stockWeight === 'TRU'">
                      Standard
                    </span>
                    <span v-if="this.jobItem.printJobSpec.stockWeight !== 'INTRAN' && this.jobItem.printJobSpec.stockWeight !== 'LF23'  && this.jobItem.printJobSpec.stockWeight !== 'TRU'  && this.jobItem.printJobSpec.stockWeight !== null  && this.jobItem.printJobSpec.stockWeight !== '' ">
                      {{ this.jobItem.printJobSpec.stockWeight }}gsm
                    </span>
                  </div>
                </div>
                <div class="layout__padding-clear">
                  <div class="component__columns-2__no-padding">Finishing</div>
                  <div class="component__columns-2__no-padding text__transform-upper">
                    <span v-if="this.jobItem.printJobSpec.lamination === null">Not Selected</span>
                    <span v-if="this.jobItem.printJobSpec.lamination === 'STANDARD' || this.jobItem.printJobSpec.lamination === 'NONE' || this.jobItem.printJobSpec.lamination === 'SILK'">
                      No Lamination
                    </span>
                    <span v-if="this.jobItem.printJobSpec.lamination !== null && this.jobItem.printJobSpec.lamination !== 'STANDARD' && this.jobItem.printJobSpec.lamination !== 'NONE' && this.jobItem.printJobSpec.lamination !== 'SILK'">
                      <span v-if="this.jobItem.printJobSpec.lamination === 'GLOSS LAM'">Gloss Lamination</span>
                      <span v-if="this.jobItem.printJobSpec.lamination === 'MATT LAM'">Matt Lamination</span>
                      <span v-if="this.jobItem.printJobSpec.lamination === 'VELVET LAM'">Velvet Lamination</span>
                      <span v-if="this.jobItem.printJobSpec.lamination === 'SIMPLEX GLOSS'">Simplex Gloss Lamination
                      </span>
                      <span v-if="this.jobItem.printJobSpec.lamination === 'SIMPLEX MATT'">Simplex Matt Lamination
                      </span>
                    </span>
                  </div>
                </div>
                <div
                  v-if="jobItem.printJobSpec.envelopeAvailable"
                  class="layout__padding-clear"
                >
                  <div class="component__columns-2__no-padding">Envelope</div>
                  <div class="component__columns-2__no-padding text__transform-upper">
                    {{ jobItem.printJobSpec.envelope ? 'Yes' : 'No' }}
                  </div>
                </div>
                <div class="layout__padding-clear">
                  <div class="component__columns-2__no-padding">Quantity</div>
                  <div class="component__columns-2__no-padding text__transform-upper">
                    {{ this.jobItem.printJobSpec.quantity }}
                  </div>
                </div>


                <div class="layout__padding-clear">
                </div>
                <div class="layout__padding-clear">
                </div>

                <div class="layout__width-100 layout__margin__top-4 layout__border__top-1px-909399">
                  <div class="component__columns-2__no-padding text__colour-teal">Subtotal (ex. VAT)</div>
                  <span class="component__columns-2__no-padding">{{ formatCurrencyTwoPlaces(jobItem.netTotalPrice) }}
                  </span>
                  <br>
                  <div class="component__columns-2__no-padding text__colour-teal">Total</div>
                  <span class="component__columns-2__no-padding">
                    {{ formatCurrencyTwoPlaces(jobItem.grossTotalPrice) }}
                  </span>
                </div>
              </div>
            </span>
          </el-tab-pane>
        </el-tabs>

        <div class="layout__padding-clear layout__padding-40px-0 layout__width-90">
          <div class="component__columns-4">
            <p class="black">Recommended Star Buy</p>
            <div class="icon-promote text__colour-red text__size-24"></div>
          </div>
          <div class="component__columns-2__no-padding">
            <div class="text__align-center">
              <el-button
                class="button-teal button__base layout__width-150px layout__margin__right-20px"
                @click="startAgain()"
              >
                Start again
              </el-button>
              <el-button
                class="button-red button__base layout__width-150px"
                :disabled="incompleteOrder || isLoading"
                @click="next()"
              >
                Checkout
              </el-button>
            </div>
          </div>
          <div class="component__columns-4">
            <div class="text__align-right text__size-12">
              You can confirm your order before payment, including
              any items previously added to the basket
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from 'axios';
import Router from '../../../router';
import StepGuide from '@/components/tools/pdfupload/StepGuide.vue';
import { axios } from '@/mixins/Axios.js';
import { dataFormatter } from '@/mixins/DataFormatter.js';
import { backing } from '@/mixins/Backing.js';
import { Loading } from 'element-ui';

export default {
  name: 'selections',

  components: {
    StepGuide,
  },

  props: {
    searchParams: Object,
    printJob: Object,
    preferences: Object,
  },

  mixins: [axios, dataFormatter, backing],

  data() {
    const validateQuantity = (rule, value, callback) => {
      console.log('this.jobItem.printJobSpec.quantity=' + this.jobItem.printJobSpec.quantity);
      console.log('this.minQuantity=' + this.minQuantity);

      if (this.jobItem.printJobSpec.quantity < this.minQuantity || this.jobItem.printJobSpec.quantity < 1) {
        callback(new Error('Minimum order quantity ' + this.minQuantity + ' for this product'));
      } else {
        callback();
      }
    };

    return {
      disableSelections: false,
      weights: [],
      types: [],
      laminations: [],
      quantities: [],
      minQuantity: 0,
      jobReference: '',
      activeName: ['1'],
      tabPosition: 'top',
      activeTab: 'style',
      jobItem: {},
      isLoading: false,
      rules: {
        quantity: [{
          message: '',
          trigger: 'blur',
        },
          {
            validator: validateQuantity,
          }],
      },
    };
  },

  computed: {
    incompleteOrder() {
      return ! (this.jobItem.printJobSpec.stockWeight !== null && this.jobItem.printJobSpec.productRef !== null && this.jobItem.printJobSpec.lamination !== null && this.jobItem.printJobSpec.quantity > 0 && this.jobItem.grossTotalPrice > 0.00 && this.jobItem.grossTotalPrice > 0);
    },
  },

  created() {
    this.isLoading = true;

    this.jobItem = this.printJob;

    if (typeof this.preferences === 'undefined' && JSON.parse(window.sessionStorage.getItem('_ipPreference'))) {
      this.preferences = JSON.parse(window.sessionStorage.getItem('_ipPreference'));
    }

    if (typeof this.jobItem === 'undefined') {
      this.jobItem = JSON.parse(window.sessionStorage.getItem('_printJob'));
      console.log(this.jobItem);
    }

    this.jobReference = window.sessionStorage.getItem('_propertyName');
    const priceSelections = JSON.parse(window.sessionStorage.getItem('_getPriceSelection'));

    if (priceSelections && priceSelections.fCode !== this.jobItem.printJobSpec.fCode) {
      Router.push({
        name: '/instant-print/error',
        params: {
          printJob: this.jobItem,
          errorType: 'noresults',
          issue: 'artworkChecks',
        },
      });

      window.sessionStorage.removeItem('_getPriceSelection');

      return;
    }

    if ((typeof this.preferences !== 'undefined' && this.preferences.fCode !== '') || priceSelections && priceSelections.fCode === this.jobItem.printJobSpec.fCode) {
      sessionStorage.setItem('_currentPrintPreference', JSON.stringify(this.preferences));

      this.jobItem.printJobSpec.stockType = this.preferences.stockType;
      this.jobItem.printJobSpec.stockWeight = this.preferences.stockWeight;
      this.jobItem.printJobSpec.lamination = this.preferences.lamination;
      this.jobItem.printJobSpec.productRef = this.preferences.productRef;
      this.jobItem.printJobSpec.quantity = this.preferences.quantity;

      if (priceSelections) {
        this.preferences.stockType = priceSelections.stockType;
        this.preferences.stockWeight = priceSelections.stockWeight;
        this.preferences.lamination = priceSelections.lamination;
        this.preferences.productRef = priceSelections.productRef;
        this.preferences.quantity = priceSelections.quantity;

        this.jobItem.printJobSpec.productRef = priceSelections.productRef;
        this.jobItem.printJobSpec.stockType = priceSelections.stockType;
        this.jobItem.printJobSpec.stockWeight = priceSelections.stockWeight;
        this.jobItem.printJobSpec.quantity = priceSelections.quantity;
        this.jobItem.printJobSpec.lamination = priceSelections.lamination;

        window.sessionStorage.removeItem('_getPriceSelection');
      }

      console.log('saving the preferences all at once');

      const url = `${process.env.VUE_APP_PDFUPLOADAPIHOST}/api/v1/pdfUpload/orders/` + this.jobItem.id;

      console.log(url);

      const savePrintJobSpec = {
        'printJobSpec': {
          'stockType': this.preferences.stockType,
          'stockWeight': this.preferences.stockWeight,
          'lamination': this.preferences.lamination,
          'productRef': this.preferences.productRef,
          'quantity': Number(this.preferences.quantity),

        },
      };


      this.disableSelections = ! (this.preferences.stockType !== 'LF23' && this.preferences.stockType !== 'INTRAN' && this.preferences.stockType !== 'TRU');

      this.activeTab = 'quantity';

      console.log('Save printJobSpec body');
      console.log(savePrintJobSpec);

      Axios.put(url, savePrintJobSpec, this.returnHeaderUsingToken())
        .then(response => {
          console.log('**** inside with preferences ****');

          console.log(response.data.printJobSpec);
          console.log(response.data);
          this.jobItem = response.data;

          this.disableSelections = ! (this.jobItem.printJobSpec.stockType !== 'LF23' && this.jobItem.printJobSpec.stockType !== 'INTRAN' && this.jobItem.printJobSpec.stockType !== 'TRU');

          this.activeTab = this.tabsResolver();

          this.isLoading = false;
        })
        .catch(() => {
          console.log('**** inside with error ****');

          this.activeTab = this.tabsResolver();

          this.isLoading = false;
        });
    }

    console.log('**** outside no preferences ****');

    this.getPaperTypes();

    if (this.jobItem.printJobSpec.stockType !== null) {
      this.getPaperWeights();
    }

    if (this.jobItem.printJobSpec.stockWeight !== null && this.jobItem.printJobSpec.stockType !== null) {
      this.getLaminations();
    }

    if (this.jobItem.printJobSpec.stockWeight !== null && this.jobItem.printJobSpec.stockType !== null && this.jobItem.printJobSpec.lamination !== null) {
      this.getQuantities();

      if (this.jobItem.printJobSpec.stockType === 'LF23' || this.jobItem.printJobSpec.stockType === 'INTRAN' || this.jobItem.printJobSpec.stockType === 'TRU') {
        this.disableSelections = true;
      }
    }

  },

  beforeUpdate() {
    // console.log('*%*%*%*% updating the printJobSpec *%*%*%*%')
    // console.log(this.jobItem.printJobSpec)

    // window.sessionStorage.setItem('_printJob', JSON.stringify(this.jobItem));
    this.handlePrintJobs(this.jobItem);
  },

  mounted() {
    document.getElementById('success').style.display = 'none';
    document.getElementById('error').style.display = 'none';
  },

  methods: {
    tabsResolver() {
      if (!this.jobItem.printJobSpec.stockType) {
        return 'style';
      }

      if (!this.jobItem.printJobSpec.stockWeight) {
        return 'weight';
      }

      if (!this.jobItem.printJobSpec.lamination) {
        return 'lam';
      }

      return 'quantity';
    },

    next() {
      if (this.jobItem.printJobSpec.quantity >= this.minQuantity) {
        this.isLoading = true;

        console.log('greater than or min quantity');

        const url = `${process.env.VUE_APP_PDFUPLOADAPIHOST}/api/v1/pdfUpload/orders/` + this.jobItem.id;

        const selectQuantity = {
          'printJobSpec': {
            'quantity': Number(this.jobItem.printJobSpec.quantity),
            'Envelope': !!this.jobItem.printJobSpec.envelope,
          },
        };

        console.log(selectQuantity);

        Axios.put(url, selectQuantity, this.returnHeaderUsingToken())
          .then(response => {
            console.log(response);
            this.jobItem = response.data;

            this.jobItem.grossTotalPrice = this.jobItem.grossTotalPrice.toFixed(2);
            this.jobItem.netTotalPrice = this.jobItem.netTotalPrice.toFixed(2);
            this.jobItem.vatTotalPrice = this.jobItem.vatTotalPrice.toFixed(2);

            this.isLoading = false;

            Router.push({
              name: '/instant-print/checkout',
              params: {
                printJob: this.jobItem,
                searchParams: this.searchParams,
              },
            });
          })
          .catch(error => {
            this.isLoading = false;

            if (error.response.status === 500) {
              // todo better error handling
            }
          });
      }
    },

    startAgain() {
      Router.push({
        name: '/instant-print',
        params: {
          printJob: this.jobItem,
          searchParams: this.searchParams,
        },
      });
    },

    getPaperTypes() {
      this.isLoading = true;

      const urlStockType = `${process.env.VUE_APP_PDFUPLOADAPIHOST}/api/v1/pdfUpload/Catalogue/FindStockTypeAsync`;

      const getTypes = {
        'id': 0,
        'fCode': this.jobItem.printJobSpec.fCode,
        'stockType': 'string',
        'pageWidth': 0,
        'pageHeight': 0,
        'actualPageWidth': 0,
        'actualPageHeight': 0,
        'pageOrientation': 'string',
        'stockWeight': 'string',
        'lamination': 'string',
        'pageCount': 0,
        'quantity': 0,
      };

      Axios.post(urlStockType, getTypes, this.returnHeaderUsingToken())
        .then(response => {
          console.log(response.data);
          this.types = response.data;

          this.isLoading = false;
          if (this.types.length === 0) {
            Router.push({
              name: '/instant-print/error',
              params: {
                printJob: this.jobItem,
                errorType: 'noresults',
                issue: 'types',
              },
            });
          }
        });
    },

    getPaperWeights() {
      this.isLoading = true;

      const getStocks = `${process.env.VUE_APP_PDFUPLOADAPIHOST}/api/v1/pdfUpload/Catalogue/FindStockWeightAsync`;

      const getStockTypes = {
        'id': 0,
        'fCode': this.jobItem.printJobSpec.fCode,
        'stockType': this.jobItem.printJobSpec.stockType,
        'pageWidth': 0,
        'pageHeight': 0,
        'actualPageWidth': 0,
        'actualPageHeight': 0,
        'pageOrientation': 'string',
        'stockWeight': 'string',
        'lamination': 'string',
        'pageCount': 0,
        'quantity': 0,
      };

      Axios.post(getStocks, getStockTypes, this.returnHeaderUsingToken())
        .then(response => {
          console.log(response);
          this.weights = response.data;

          this.isLoading = false;

          if (this.weights.length === 0) {
            Router.push({
              name: '/instant-print/error',
              params: {
                printJob: this.jobItem,
                errorType: 'noresults',
                issue: 'weights',
              },
            });
          } else {
            // move over
          }
        })
        .catch(error => {
          this.isLoading = false;

          if (error.response.status === 500) {
            console.log('500 error getting lamination');
            Router.push({
              name: '/instant-print/error',
              params: {
                printJob: this.jobItem,
                errorType: 'noresults',
                issue: 'weights',
                // todo this needs a problem creating order error
              },
            });
          }
        });
    },

    getLaminations() {
      this.isLoading = true;

      const urlLaminations = `${process.env.VUE_APP_PDFUPLOADAPIHOST}/api/v1/pdfUpload/Catalogue/FindLaminate`;

      const getLaminations = {
        'id': 0,
        'fCode': this.jobItem.printJobSpec.fCode,
        'stockType': this.jobItem.printJobSpec.stockType,
        'pageWidth': 0,
        'pageHeight': 0,
        'actualPageWidth': 0,
        'actualPageHeight': 0,
        'pageOrientation': 'string',
        'stockWeight': this.jobItem.printJobSpec.stockWeight,
        'lamination': 'string',
        'pageCount': 0,
        'quantity': 0,
      };

      Axios.post(urlLaminations, getLaminations, this.returnHeaderUsingToken())
        .then(response => {
          console.log(response);
          this.laminations = response.data;

          this.isLoading = false;
          if (this.laminations.length === 0) {
            Router.push({
              name: '/instant-print/error',
              params: {
                printJob: this.jobItem,
                errorType: 'noresults',
                issue: 'laminations',
              },
            });
          }
        });
    },

    getQuantities() {
      this.isLoading = true;

      const urlQuantities = `${process.env.VUE_APP_PDFUPLOADAPIHOST}/api/v1/pdfUpload/Catalogue/FindMinimumQuantity`;

      const getQuantities = {
        'id': 0,
        'fCode': 'string',
        'stockType': 'string',
        'pageWidth': 0,
        'pageHeight': 0,
        'actualPageWidth': 0,
        'actualPageHeight': 0,
        'pageOrientation': 'string',
        'stockWeight': 0,
        'productRef': this.jobItem.printJobSpec.productRef,
        'lamination': 'string',
        'pageCount': 0,
        'quantity': 0,
      };

      console.log('GET_QUANTITIES');
      console.log(getQuantities);

      Axios.post(urlQuantities, getQuantities, this.returnHeaderUsingToken())
        .then(response => {
          this.minQuantity = response.data;

          this.isLoading = false;

          if (this.minQuantity === 0) {
            Router.push({
              name: '/instant-print/error',
              params: {
                printJob: this.jobItem,
                errorType: 'noresults',
                issue: 'quantities',
              },
            });
          } else {

            // if (this.minQuantity == 16) {
            //     this.minQuantity = 10
            // }
            this.filterQuantity();
          }
        });
    },

    postPaperType() {
      this.isLoading = true;

      const url = `${process.env.VUE_APP_PDFUPLOADAPIHOST}/api/v1/pdfUpload/orders/` + this.jobItem.id + '?resetJobSpec=true';

      console.log(url);

      const selectTypes = {
        'printJobSpec': {
          'stockType': this.jobItem.printJobSpec.stockType,
        },
      };

      console.log('Select type body');
      console.log(selectTypes);

      Axios.put(url, selectTypes, this.returnHeaderUsingToken())
        .then(response => {
          console.log(response.data.printJobSpec);
          this.weights = [];
          this.laminations = [];
          this.quantities = [];
          this.jobItem = response.data;

          console.log('stock type for evaluation');
          console.log(this.jobItem.printJobSpec.stockType);

          this.isLoading = false;

          if (this.jobItem.printJobSpec.stockType !== 'LF23' && this.jobItem.printJobSpec.stockType !== 'INTRAN' && this.jobItem.printJobSpec.stockType !== 'TRU') {
            // todo do normal get the weight and show weight

            this.getPaperWeights();
            this.activeTab = 'weight';
            this.disableSelections = false;
          } else {
            // todo move straight to quantity and disable others x2
            this.getQuantities();
            this.disableSelections = true;
            this.activeTab = 'quantity';
          }
        });
    },

    postPaperWeights() {
      this.isLoading = true;

      const url = `${process.env.VUE_APP_PDFUPLOADAPIHOST}/api/v1/pdfUpload/orders/` + this.jobItem.id;

      const selectWeight = {
        'printJobSpec': {
          'stockWeight': this.jobItem.printJobSpec.stockWeight,
        },
      };

      console.log('select weight body');
      console.log(selectWeight);

      Axios.put(url, selectWeight, this.returnHeaderUsingToken())
        .then(response => {
          console.log(response);
          this.laminations = [];
          this.quantities = [];
          console.log('quantities');
          console.log(this.quantities);
          this.jobItem = response.data;

          this.isLoading = false;

          this.getLaminations();
          this.activeTab = 'lam';
        });

    },

    postLamination(lamination) {
      this.isLoading = true;

      const url = `${process.env.VUE_APP_PDFUPLOADAPIHOST}/api/v1/pdfUpload/orders/` + this.jobItem.id;

      console.log(url);

      const selectLamination = {
        'printJobSpec': {
          'lamination': this.jobItem.printJobSpec.lamination,
          'productRef': lamination.productRef,
        },
      };

      console.log('laminations');
      console.log(selectLamination);

      Axios.put(url, selectLamination, this.returnHeaderUsingToken())
        .then(response => {
          console.log(response);
          this.quantity = true;
          console.log(this.quantity);
          this.jobItem = response.data;

          this.isLoading = false;

          this.getQuantities();
          this.activeTab = 'quantity';
        });

    },

    postQuantity() {
      if (this.jobItem.printJobSpec.quantity >= this.minQuantity) {
        this.isLoading = true;

        console.log('greater than or min quantity');

        const url = `${process.env.VUE_APP_PDFUPLOADAPIHOST}/api/v1/pdfUpload/orders/` + this.jobItem.id;

        const selectQuantity = {
          'printJobSpec': {
            'quantity': Number(this.jobItem.printJobSpec.quantity),
            'Envelope': !!this.jobItem.printJobSpec.envelope,
          },
        };

        console.log(selectQuantity);

        Axios.put(url, selectQuantity, this.returnHeaderUsingToken())
          .then(response => {
            console.log(response);
            this.jobItem = response.data;

            this.jobItem.grossTotalPrice = this.jobItem.grossTotalPrice.toFixed(2);
            this.jobItem.netTotalPrice = this.jobItem.netTotalPrice.toFixed(2);
            this.jobItem.vatTotalPrice = this.jobItem.vatTotalPrice.toFixed(2);

            this.isLoading = false;
          })
          .catch(error => {
            this.isLoading = false;

            if (error.response.status === 500) {
              // todo better error handling
            }
          });
      }
    },

    filterQuantity() {
      const filteringQuantities = [
        '1',
        '2',
        '5',
        '8',
        '10',
        '16',
        '30',
        '50',
        '100',
        '250',
        '500',
        '750',
        '1000',
        '2500',
      ];

      this.quantities = [];

      filteringQuantities.forEach(quantity => {
        if (quantity >= this.minQuantity) {
          this.quantities.push(quantity);
        }
      });
    },

    savePreferences() {

      let loadingInstance = Loading.service({
        fullscreen: true,
      });

      let customerRef = JSON.parse(this.returnCookie('_customer')).ref;

      console.log(customerRef);

      let skuFinder = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/api/services/app/Catalogues/SaveCatalogueBookmark/?catalogueRef=${process.env.VUE_APP_CATALOGUE_REF}&orderSource=PDFUPLOAD&customerRef=` + customerRef + '&priceCode=' + this.jobItem.productPriceCode + '&quantity=' + this.jobItem.printJobSpec.quantity;

      console.log(skuFinder);

      console.log(this.returnHeaderUsingToken());

      Axios.put(skuFinder, {}, this.returnHeaderUsingToken())
        .then(response => {
          console.log(response);

          let customerRef = JSON.parse(this.returnCookie('_customer')).ref;

          console.log(customerRef);

          this.getUserPreferences(customerRef);

          document.getElementById('success').style.display = 'block';

          this.$nextTick(() => { // Loading should be closed asynchronously
            loadingInstance.close();
          });
        })
        .catch(() => {
          document.getElementById('error').style.display = 'block';
          this.$nextTick(() => { // Loading should be closed asynchronously
            loadingInstance.close();
          });
        });

    },
  },
};
</script>
